import script from "./ResumeConfirmView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ResumeConfirmView.vue?vue&type=script&lang=ts&setup=true"

import "./ResumeConfirmView.vue?vue&type=style&index=0&id=617c67b6&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-617c67b6"]])

export default __exports__